import React from 'react';
import { FiCheck } from 'react-icons/fi';
import { useInView } from '../../hooks/useInView';
import '../../App.css';

const features = [
  "Enterprise-grade security",
  "Continuous deployment",
  "Scalable architecture",
  "Compliance ready"
];

function FeaturesSection() {
  const { ref, isVisible } = useInView();

  return (
    <section className="features-section" ref={ref}>
      <div className="container">
        <div className={`features-header ${isVisible ? 'visible' : ''}`}>
          <span className="section-label">Our Methodology</span>
          <h2 className="section-title">Engineered for Excellence</h2>
        </div>
        <ul className="features-list">
          {features.map((feature, index) => (
            <li
              key={index}
              className={`feature-item ${isVisible ? 'visible' : ''}`}
              style={{ animationDelay: `${index * 50}ms` }}
            >
              <div className="feature-icon">
                <FiCheck />
              </div>
              <div className="feature-content">
                <h3 className="feature-title">{feature}</h3>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}

export default FeaturesSection;
